export enum CharKeyCode {
  ESC = 'ESCAPE'
}
